var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import client from "../http/client";
var ServiceTypesContext = createContext(undefined);
var toBoolean = function (value) {
    if (typeof value === "boolean") {
        return value;
    }
    if (typeof value === "number") {
        return value === 1;
    }
    if (typeof value === "string") {
        var normalizedValue = value.trim().toLowerCase();
        return normalizedValue === "1" || normalizedValue === "true" || normalizedValue === "yes";
    }
    return false;
};
var serviceTypeIsAvailableForMenu = function (serviceType) {
    var _a;
    var store = (_a = window.session) === null || _a === void 0 ? void 0 : _a.store;
    if (!toBoolean(store === null || store === void 0 ? void 0 : store.is_catering)) {
        return true;
    }
    return toBoolean(serviceType.catering_enabled);
};
var normalizeServiceTypes = function (serviceTypesInput) {
    if (Array.isArray(serviceTypesInput)) {
        return serviceTypesInput.filter(function (serviceType) {
            return Boolean(serviceType && typeof serviceType === "object" && "id" in serviceType && serviceTypeIsAvailableForMenu(serviceType));
        });
    }
    if (typeof serviceTypesInput !== "string") {
        return [];
    }
    try {
        var parsed = JSON.parse(serviceTypesInput);
        if (!Array.isArray(parsed)) {
            return [];
        }
        return parsed.filter(function (serviceType) {
            return Boolean(serviceType && typeof serviceType === "object" && "id" in serviceType && serviceTypeIsAvailableForMenu(serviceType));
        });
    }
    catch (_error) {
        return [];
    }
};
export var ServiceTypesProvider = function (_a) {
    var _b;
    var children = _a.children;
    var initialServiceTypes = normalizeServiceTypes((_b = window.session) === null || _b === void 0 ? void 0 : _b.service_types);
    var _c = useState(initialServiceTypes), serviceTypes = _c[0], setServiceTypesState = _c[1];
    var _d = useState(initialServiceTypes.length === 0), isLoading = _d[0], setIsLoading = _d[1];
    var setServiceTypes = useCallback(function (nextServiceTypes) {
        setServiceTypesState(nextServiceTypes);
        setIsLoading(false);
    }, []);
    var refreshServiceTypes = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, normalizedServiceTypes;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, client.get("/store/service_types/api")];
                case 2:
                    response = _a.sent();
                    normalizedServiceTypes = normalizeServiceTypes(response.data);
                    setServiceTypesState(normalizedServiceTypes);
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        if (serviceTypes.length > 0) {
            return;
        }
        refreshServiceTypes().catch(function () {
            var _a;
            // Session payload is used as fallback data source when API fetch fails.
            var fallbackTypes = normalizeServiceTypes((_a = window.session) === null || _a === void 0 ? void 0 : _a.service_types);
            setServiceTypesState(fallbackTypes);
            setIsLoading(false);
        });
    }, [serviceTypes.length, refreshServiceTypes]);
    var value = useMemo(function () { return ({
        serviceTypes: serviceTypes,
        isLoading: isLoading,
        setServiceTypes: setServiceTypes,
        refreshServiceTypes: refreshServiceTypes,
    }); }, [serviceTypes, isLoading, setServiceTypes, refreshServiceTypes]);
    return (React.createElement(ServiceTypesContext.Provider, { value: value }, children));
};
export var useServiceTypes = function () {
    var context = useContext(ServiceTypesContext);
    if (!context) {
        throw new Error("useServiceTypes must be used within a ServiceTypesProvider");
    }
    return context;
};
